import React from "react";
import { Flame } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const next = location.state?.next || "/";

    const handleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/auth/callback";
        // Persist intended next path so AuthCallback can route back
        try {
            sessionStorage.setItem("flexfeed_next", next);
        } catch {}
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div data-testid="login-page" className="min-h-[100dvh] bg-[#0A0A0A] text-white flex flex-col">
            <div className="relative flex-1 flex flex-col items-center justify-center px-6">
                <img
                    alt=""
                    src="https://static.prod-images.emergentagent.com/jobs/1f22cf28-b917-4140-9ab6-3cd1851d807d/images/fa0e6546bdef8c63c45ce9948cae755f0c7feabb511010e8f6bb2ecf2a263b5c.png"
                    className="absolute inset-0 w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/70 to-[#0A0A0A]" />
                <div className="relative w-full max-w-sm flex flex-col items-center text-center">
                    <div className="w-14 h-14 rounded-full bg-[#E1FF01] flex items-center justify-center mb-5">
                        <Flame className="text-[#0A0A0A]" size={26} strokeWidth={2.5} />
                    </div>
                    <p className="font-display text-2xl tracking-widest mb-2">FLEXFEED</p>
                    <h1 className="font-display text-5xl uppercase leading-[0.95] mb-3">
                        Train hard.<br />Pay smart.
                    </h1>
                    <p className="text-sm text-white/70 mb-10">
                        Sign in to subscribe to workout plans, save recipes, and earn free weeks
                        through referrals.
                    </p>
                    <button
                        data-testid="google-signin"
                        onClick={handleLogin}
                        className="w-full bg-white text-[#0A0A0A] font-display text-xl uppercase tracking-wider py-3.5 rounded-md flex items-center justify-center gap-2 active:scale-[0.98] transition"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
                        </svg>
                        Continue with Google
                    </button>
                    <button
                        data-testid="back-to-feed"
                        onClick={() => navigate("/")}
                        className="mt-3 text-xs uppercase tracking-widest text-white/50 hover:text-white"
                    >
                        Back to feed
                    </button>
                    <button
                        data-testid="login-see-demo"
                        onClick={() => navigate("/demo")}
                        className="mt-2 text-[11px] uppercase tracking-widest text-[#E1FF01]/80 hover:text-[#E1FF01]"
                    >
                        See how it works →
                    </button>
                    <p className="text-[10px] text-white/30 uppercase tracking-widest mt-10">
                        Stripe test mode · No real charges
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
